import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import { employeeIconStyles } from './employee-utils';
import { useTranslation } from 'react-i18next';

interface ActionButtonsProps {
  employeeId: string;

  handleRemoveConfirmation: (id: string) => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  employeeId,
  handleRemoveConfirmation
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Tooltip title={t('remove_employee')}>
        <IconButton onClick={() => handleRemoveConfirmation(employeeId)}>
          <DeleteIcon sx={employeeIconStyles} />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default ActionButtons;
